<template>
	<div @click.stop>
		<div v-if="showMore" class="dynvibeChartMore">
			<i class="icon-info-circle" style="color: #ccc; padding-left: 10px"></i>
			<ul style="list-style: none; padding-left: 0px; margin-bottom: 0px; margin-top: 15px">
				<li class="dynvibePrintChart" @click="downloadChart('print')"><i class="icon-print"></i> Print chart</li>
				<li class="dynvibeDownloadChart" @mouseover="showMoreHover = true" @mouseleave="showMoreHover = false">
					<i class="icon-download"></i> Download as ...
					<i
						class="icon-chevron-right"
						style="float: right; margin: 0px; height: 20px; width: auto; display: flex; align-items: center; font-size: 10px"
					></i>
					<ul v-if="showMoreHover" class="subMenu">
						<li @click="downloadChart('PNG')">PNG</li>
						<li @click="downloadChart('JPEG')">JPEG</li>
						<li @click="downloadChart('PDF')">PDF</li>
						<li @click="downloadChart('SVG')">SVG</li>
						<li @click="downloadChart('CSV')">CSV</li>
						<li @click="downloadChart('XLS')">XLS</li>
					</ul>
				</li>
			</ul>
		</div>
		<div class="dynvibeChartMoreButton" @click="showMore = !showMore">
			<i class="icon-ellipsis"></i>
		</div>
	</div>
</template>

<script>
export default {
	props: {},
	data() {
		return {
			showMore: false,
			showMoreHover: false,
		};
	},
	methods: {
		printChart() {
			this.$refs.highcharts.chart.print();
		},
		downloadChart(downloadType) {
			this.$emit("download", downloadType);
		},
	},
};
</script>

<style scoped>
.dynvibeChartMoreButton {
	position: absolute;
	right: 15px;
	z-index: 1;
	display: flex;
	align-items: center;
	width: 25px;
	height: 25px;
	cursor: pointer;
	float: right;
}

.dynvibeChartMoreButton i {
	color: #9e9e9e;
	margin: 0 auto;
}

.dynvibeChartMoreButton:hover i {
	color: #757575;
}

.dynvibeChartMore {
	position: absolute;
	right: 15px;
	width: 200px;
	top: 0;
	padding: 10px 0px;
	z-index: 1;
	background-color: #fff;
	border-bottom: 7px solid #33d1cd;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
	color: #757575;
}

.dynvibeChartMore.active {
	display: block;
}

.dynvibeChartMore li {
	padding: 5px 10px;
	cursor: pointer;
}

.dynvibeChartMore li:hover {
	color: #33d1cd;
}

.dynvibeChartMore li i {
	width: 15px;
	margin-right: 10px;
	text-align: center;
}

.dynvibeChartMore li a {
	display: block;
}

.subMenu {
	position: absolute;
	width: 200px;
	right: 200px;
	margin-top: -20px;
	background-color: #fff;
	box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
	color: #757575;
	font-size: 12px;
	list-style: none;
}
</style>
